// src/utils/getRelatedPages.js
import pages from "../data/landingPages.json";

export default function getRelatedPages(currentSlug, max = 4) {
  // Alles außer der aktuellen Page
  const others = pages.filter(p => p.slug !== currentSlug);

  // 1) gleiches Präfix (z.B. "edifact-")
  const pref = currentSlug.split("-")[0];
  const prioritized = others.filter(p => p.slug.startsWith(pref));

  // 2) fallback: beliebige übrige
  const pool = [...new Set([...prioritized, ...others])];
  return pool.slice(0, max);
}
